import { DataType } from '@/screens/Order/Pages/EditOrder/components/ProductRequirementForm/measurement.column'
import HeaderComponent from '@/screens/SystemConfigure/Components/HeaderComponent/HeaderComponent'
import PopUpMenu from '@/screens/SystemConfigure/Components/PopUpMenu/PopUpMenu'
import ToolbarComponent from '@/screens/SystemConfigure/Components/ToolbarComponent/ToolbarComponent'
import { Popover, Space, Typography } from 'antd'
import Table, { ColumnsType } from 'antd/lib/table'
import { useState } from 'react'
import { useMutation, useQuery } from 'react-query'
import {
  deleteSupplier,
  getCountry,
  getSupplier,
} from '../../DataManagement.transform'
import { getCompanySetting } from '@/screens/SystemConfigure/UserManagment/UserManagment.transform'
import { COMPANY_SETTING_SHOW_UUID } from '@/constant/user'
import AddSupplierModal from './AddSupplierModal/AddSupplierModal'
import './Supplier.style.less'
import { debounce } from 'lodash'
import { isEmptyValue } from '@/utils/common'
import { CheckOutlined, CopyOutlined } from '@ant-design/icons'

function Supplier() {
  const [modalSupplier, setModalSupplier] = useState(false)
  const [selectedItem, setselectedItem] = useState(null)
  const [page, setpage] = useState(1)
  const [search, setsearch] = useState('')

  const { data: companySettingUUID } = useQuery(
    ['getCompanySettingShowUUID'],
    async () => {
      return await getCompanySetting('', COMPANY_SETTING_SHOW_UUID)
    }
  )

  const hasUUID = companySettingUUID?.value?.settings?.supplier?.status

  const onEdit = (item) => {
    setselectedItem(item)
    setModalSupplier(true)
  }

  const onAdd = () => {
    setselectedItem(null)
    setModalSupplier(true)
  }

  const deleteMutation = useMutation(async (data: any) => {
    await deleteSupplier(data)
    await refetch()
  })

  const onDelete = (data) => {
    deleteMutation.mutate(data)
  }

  const columns: ColumnsType<DataType> = [
    ...(hasUUID
      ? [
          {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            width: 200,
            render: (id: string) => (
              <div className="copyable-on-hover">
                <Typography.Text
                  copyable={{
                    icon: [
                      <CopyOutlined
                        key="copy-icon"
                        style={{ color: '#848484' }}
                      />,
                      <CheckOutlined
                        key="check-icon"
                        style={{ color: '#52c41a' }}
                      />,
                    ],
                    tooltips: ['Copy ID', 'Copied!'],
                  }}
                >
                  {id}
                </Typography.Text>
              </div>
            ),
          },
        ]
      : []),
    {
      title: 'SUPPLIER NAME',
      dataIndex: 'name',
      key: 'name',
      // sorter: (a: any, b: any) => a.name.length - b.name.length,
    },
    {
      title: 'COUNTRY',
      dataIndex: 'country',
      key: 'country',
      render: (_, record: any) => {
        return <p>{record?.country?.name}</p>
      },
    },
    {
      title: 'DOCUMENTS',
      dataIndex: 'country',
      key: 'country',

      render: (_, record: any) => {
        if (
          isEmptyValue(
            record?.property_value?.values.find(
              (item) => item.field == 'documents'
            )?.value
          )
        )
          return <div />
        return (
          <Popover
            content={
              <div className="popover-url">
                <ul>
                  {record?.property_value?.values
                    .find((item) => item.field == 'documents')
                    ?.value?.map((item) => {
                      return (
                        <li key={item.uid}>
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href={item.url}
                            key={item}
                            style={{ color: '#4a8dc0' }}
                          >
                            {item.name}
                          </a>
                        </li>
                      )
                    })}
                </ul>
              </div>
            }
            title="Files"
            trigger="hover"
          >
            <p className="file-url-name">Files</p>
          </Popover>
        )
      },
    },
    {
      title: 'IS FACTORY',
      dataIndex: 'is_factory',
      key: 'is_factory',
      render: (_, record: any) => {
        return <p>{record?.is_factory ? 'Yes' : ''}</p>
      },
    },
    {
      title: 'ACTION',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <PopUpMenu
            onEdit={() => onEdit(record)}
            onDelete={() => onDelete(record)}
          />
        </Space>
      ),
      width: 90,
    },
  ]

  const { data, isLoading, refetch } = useQuery(
    ['Supplier', page, search],
    async () => {
      const payload = {
        page_number: page,
        page_size: 10,
        status: 'active',
        type: 'supplier',
        search: search,
      }
      return await getSupplier(payload)
    }
  )

  const { data: country } = useQuery(['Country'], async () => {
    return await getCountry()
  })

  const onSearch = debounce(async (value) => {
    setsearch(value)
  }, 500)

  return (
    <>
      <HeaderComponent title="Supplier" />
      <ToolbarComponent
        onAdd={onAdd}
        buttonText="New Supplier"
        onSearch={onSearch}
      />
      <Table
        tableLayout="fixed"
        loading={isLoading}
        columns={columns}
        dataSource={data?.data}
        pagination={{
          pageSize: 10,
          current: page,
          onChange(page) {
            setpage(page)
          },
          total: data?.pagination.total_record,
        }}
      />
      {modalSupplier && (
        <AddSupplierModal
          visible={modalSupplier}
          onClose={() => setModalSupplier(false)}
          data={selectedItem}
          country={country}
        />
      )}
    </>
  )
}

export default Supplier
